import React from 'react'
import BrandSkoda from '../vectors/BrandSkoda'
import BrandKia from '../vectors/BrandKia'
import BrandVw from '../vectors/BrandVw'
import IconArrowDown from '../vectors/IconArrowDown'

const Link = (props) => (
  <a className="link" {...props}>
    {' '}
    {props.children}{' '}
  </a>
)

const sliderRange = { min: 0, max: 40000, factor: 500 }

const filterSort = {
  ASCENDING: {
    property: 'price',
    direction: 'ascending',
    label: 'Low - High',
    icon: <IconArrowDown />
  },
  DESCENDING: {
    property: 'price',
    direction: 'descending',
    label: 'High - Low',
    icon: <IconArrowDown />
  }
}
const filterState = {
  sort: filterSort.ASCENDING,
  hidden: true,
  criteria: [],
  price: {
    values: [sliderRange.min, sliderRange.max],
    min: sliderRange.min,
    max: sliderRange.max
  },
  keywords: {
    tags: []
  }
}

const sections = [
  { label: 'Cars', slug: 'cars', root: true },
  { label: 'Vans', slug: 'vw-commercial' },
  { label: 'Fleet', slug: 'business' },
  { label: 'Locations', slug: 'locations' },
  { label: 'Blog', slug: 'blog' },
  { label: 'About us', slug: 'about-us' },
  { label: 'Careers', slug: 'careers' },
  { label: 'Motability', slug: 'motability' },
  { label: 'Finance', slug: 'finance' }
]

const subSections = [
  { label: 'New', slug: 'new', type: 'cars', root: true },
  { label: 'Used', slug: 'used', type: 'cars' },
  { label: 'Offers', slug: 'offers', type: 'cars' },
  { label: 'Finance', slug: 'finance', type: 'cars' },
  { label: 'Servicing', slug: 'servicing', type: 'cars' }
]

const contextSections = [
  { label: 'Features', slug: 'features', root: true },
  { label: 'Technical', slug: 'technical', pairs: true },
  { label: 'Interior', slug: 'interior', pairs: true },
  { label: 'Exterior', slug: 'exterior', pairs: true },
  { label: 'Safety', slug: 'safety', pairs: true }
]

const contextMakesSections = [
  { label: 'hatchbacks', slug: 'hatchbacks', root: true },
  { label: 'saloons', slug: 'saloons' },
  { label: 'estates', slug: 'estates' },
  { label: 'coupes & convertibles', slug: 'coupes-and-convertibles' },
  { label: 'suvs', slug: 'suvs' }
]

const brands = [
  { make: 'VW', slug: 'new/volkswagen', type: 'cars', asset: <BrandVw /> },
  { make: 'Skoda', slug: 'new/skoda', type: 'cars', asset: <BrandSkoda /> },
  { make: 'Kia', slug: 'new/kia', type: 'cars', asset: <BrandKia /> }
]

const searchItems = [
  {
    label: 'Brand',
    link: '/search/volkswagen/',
    items: [
      {
        label: (
          <span>
            <strong>Volks</strong>wagen
          </span>
        ),
        link: '/cars/volkswagen/',
        image: {
          path: '/temp/brand-vw',
          ext: '.svg'
        },
        category: 'brands'
      }
    ]
  },
  {
    label: 'New',
    link: '/search/cars/new',
    items: [
      {
        label: (
          <span>
            <strong>Volks</strong>wagen Golf
          </span>
        ),
        link: '/cars/new/golf',
        image: {
          path: '/temp/temp_volkswagen',
          ext: '.png'
        },
        category: 'new'
      },
      {
        label: (
          <span>
            <strong>Volks</strong>wagen Golf GTI
          </span>
        ),
        link: '/cars/new/golf-gti',
        image: {
          path: '/temp/temp_volkswagen',
          ext: '.png'
        },
        category: 'new'
      }
    ]
  },
  {
    label: 'Used',
    link: '/search/cars/used',
    items: [
      {
        label: (
          <span>
            <strong>Volks</strong>wagen Golf 170-hp 1.8L Turbo
          </span>
        ),
        link: '/cars/used/',
        image: {
          path: '/temp/temp_volkswagen',
          ext: '.png'
        },
        category: 'used'
      }
    ]
  },
  {
    label: 'Other',
    items: [
      {
        label: (
          <span>
            <strong>Volks</strong>wagen Golf - That is All You Need to Know.
            This stunning piece of visual theatre tells the story of Bletchley
            Park and the untold secrets of the remarkable men and women who
          </span>
        ),
        link: '/blog/news/',
        category: 'news'
      }
    ]
  }
]

const article = {
  excerpt: 'I speak Latin because I am a fancy man. Lorem ipsum dolor sit amet',
  frontmatter: {
    date: '2017-07-18T13:35:13.234Z',
    image: '//images.unsplash.com/photo-1488922034043-e151c4cc4731?w=1282&q=20',
    path: '/blog/news/sample-event',
    tags: ['events'],
    title: 'Sample Event'
  },
  html: '<p>I speak Latin because I am a fancy man.</p>↵<p>Lorem ipsum dolor sit amet, co</p>',
  id: '',
  timeToRead: 2
}

const signpostArticles = [
  {
    subheading: 'VW offer',
    heading: '£1800 towards your deposit',
    sell: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam hendrerit bibendum quam non iaculis. Nam vitae ligula rutrum augue bibendum finibus ut vel neque.',
    callToActionLink: '/cars/new',
    callToActionText: 'View offers',
    image: 'v1515608371/temp-signpost01_2x'
  },
  {
    subheading: 'New car',
    heading: 'Introducing the new eGolf',
    sell: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam hendrerit bibendum quam non iaculis. Nam vitae ligula rutrum augue bibendum finibus ut vel neque.',
    callToActionLink: '/cars/new',
    callToActionText: 'Read article',
    image: 'v1515608461/temp-signpost-02_2x'
  }
]

const footerSiteLinks = [
  {
    label: 'Cars',
    href: '/cars/new',
    links: [
      { label: 'New Cars', href: '/cars/new' },
      { label: 'Used Cars', href: '/cars/used' },
      { label: 'Car Offers', href: '/cars/offers' },
      { label: 'Car Servicing', href: '/servicing' },
      { label: 'Sell Your Car', href: '/cars/sell-your-car' },
      { label: 'Rent-A-Car', href: '/vwfs-rent-a-car' }
    ]
  },
  {
    label: 'Vans',
    href: '/vw-commercial',
    links: [
      { label: 'New Vans', href: '/vw-commercial' },
      { label: 'Used Vans', href: '/vans/used' },
      { label: 'Van Offers', href: '/vans/offers' },
      { label: 'Van Servicing', href: '/servicing' },
      { label: 'Sell Your Van', href: '/vans/sell-your-van' },
      { label: 'Rent-A-Van', href: '/rental/vans' }
    ]
  },
  {
    label: 'Locations',
    href: '/locations',
    locations: true
  },
  {
    label: 'More',
    links: [
      { label: 'Volkswagen Cars', href: '/volkswagen/' },
      { label: 'VW Commercial Vehicles', href: '/vw-commercial/' },
      { label: 'ŠKODA Cars', href: '/skoda/' },
      { label: 'SEAT Cars', href: '/seat/' },
      { label: 'Kia Cars', href: '/kia/' },
      { label: 'Careers', href: '/careers/' },
      { label: 'Finance', href: '/finance/' },
      { label: 'Academy of Excellence', href: '/academy/' },
      { label: 'Warranty & Protection', href: '/warranty-and-protection' }
    ]
  }
]

const articles = [
  {
    id: '5b083634a0791d233511c766',
    headline: 'Citygate Kia Slough Opens for Business',
    shortHeadline: 'Citygate Kia Slough Opens for Business',
    slug: 'citygate-kia-slough-opens-for-business',
    displayDate: '2018-05-25T16:08:00.000Z',
    images: ['cms/wejjs4wjj0f9qyquwpvp'],
    tags: ['Kia']
  },
  {
    id: '5b08247da0791d233511c764',
    headline: 'New Citygate Bodyshop Opened in Slough',
    shortHeadline: 'New Citygate Bodyshop Opened in Slough',
    slug: 'new-citygate-bodyshop-opened-in-slough',
    displayDate: '2018-05-25T14:55:00.000Z',
    images: ['cms/g283ox082mbczd2bsi27'],
    tags: ['Bodyshop']
  },
  {
    id: '5b0820880c7fa82336520490',
    headline: 'Four Stupid Ways to Damage Your Car This Winter',
    shortHeadline: 'Four Stupid Ways to Damage Your Car This Winter',
    slug: 'four-stupid-ways-to-damage-your-car-this-winter',
    displayDate: '2018-05-25T14:36:00.000Z',
    images: ['cms/un7m1d7li1zbjyhffu5t'],
    tags: ['Insight']
  }
]

const get360ShowcaseImages = function () {
  let i = 72
  let images = []
  const prefix =
    '//res.cloudinary.com/citygate/image/upload/autoloadit/Img/pic/9/20024/360/'
  const affix = '.jpg'
  function pad(n) {
    return n < 10 ? `0${n}` : `${n}`
  }
  while (i) {
    images.push(`${prefix}${pad(i)}${affix}`)
    i--
  }
  return images.reverse()
}

const get360PosterFrame = function () {
  return `//res.cloudinary.com/citygate/image/upload/autoloadit/Img/pic/9/20024/360/thumbnailMid/36.jpg`
}

const getPanoramaPoster = function () {
  return '/temp/temp-showcase-internal-360-poster.jpg'
}
const getPanoramaImage = function () {
  return '/temp/temp-showcase-internal-360.jpg'
}

const carCardDetails = [
  {
    model: 'Volkswagen Golf',
    derivative: 'GTI S',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: {
      total: 26999,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    path: '/used/cars/volkswagen-golf-gti-s/KP120WK',
    image: 'cms/rks5bcgj818ggs14lvru',
    roundel: 'low APR offer',
    offer: true
  },
  {
    model: 'Kia Sportage',
    derivative: '2',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: {
      total: 26999,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    path: '/used/cars/volkswagen-golf-gti-s/KP120WK',
    image: 'cms/ojpqmnt8a1xuykvdlpca',
    offer: false
  },
  {
    model: 'Volkswagen Golf',
    derivative: 'GTI S',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: {
      total: 26999,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    path: '/used/cars/volkswagen-golf-gti-s/KP120WK',
    image: 'v1513601945/temp-vehicle-card-square_2x',
    offer: true,
    outlined: true
  },
  {
    model: 'Volkswagen Golf',
    derivative: 'GTI S',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: {
      total: 26999,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    path: '/used/cars/volkswagen-golf-gti-s/KP120WK',
    image: 'v1513601945/temp-vehicle-cutout_2x',
    offer: true,
    outlined: false
  }
]
const carCardDetailsOutlineOnly = [
  {
    model: 'Volkswagen Golf',
    derivative: 'GTI S',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: {
      total: 26999,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    path: '/used/cars/volkswagen-golf-gti-s/KP120WK',
    image: 'v1513601945/temp-vehicle-card-square_2x',
    offer: true,
    outlined: true
  },
  {
    model: 'Volkswagen Golf',
    derivative: 'GTI S',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: {
      total: 26999,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    path: '/used/cars/volkswagen-golf-gti-s/KP120WK',
    image: 'v1513601945/temp-vehicle-card-square_2x',
    offer: true,
    outlined: true
  },
  {
    model: 'Volkswagen Golf',
    derivative: 'GTI S',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: {
      total: 26999,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    path: '/used/cars/volkswagen-golf-gti-s/KP120WK',
    image: 'v1513601945/temp-vehicle-card-square_2x',
    offer: true,
    outlined: true
  },
  {
    model: 'Volkswagen Golf',
    derivative: 'GTI S',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: {
      total: 26999,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    path: '/used/cars/volkswagen-golf-gti-s/KP120WK',
    image: 'v1513601945/temp-vehicle-card-square_2x',
    offer: true,
    outlined: true
  },
  {
    model: 'Volkswagen Golf',
    derivative: 'GTI S',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: {
      total: 26999,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    path: '/used/cars/volkswagen-golf-gti-s/KP120WK',
    image: 'v1513601945/temp-vehicle-card-square_2x',
    offer: true,
    outlined: true
  },
  {
    model: 'Volkswagen Golf',
    derivative: 'GTI S',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: {
      total: 26999,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    path: '/used/cars/volkswagen-golf-gti-s/KP120WK',
    image: 'v1513601945/temp-vehicle-card-square_2x',
    offer: true,
    outlined: true
  }
]
const carCardPopularModelsDetails = [
  {
    model: 'Volkswagen Golf',
    derivative: 'GTI S',
    details: [],
    price: {
      total: 26999,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    path: '/used/cars/volkswagen-golf-gti-s/KP120WK',
    image: 'v1515582934/vehicle-cutout-vw_2x',
    roundel: 'low APR offer',
    offer: false
  },
  {
    model: 'Volkswagen Golf',
    derivative: 'GTI S',
    details: [],
    price: {
      total: 26999,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    path: '/used/cars/volkswagen-golf-gti-s/KP120WK',
    image: 'v1515582934/vehicle-cutout-vw_2x',
    roundel: 'low APR offer',
    offer: false
  },
  {
    model: 'Volkswagen Golf',
    derivative: 'GTI S',
    details: [],
    price: {
      total: 26999,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    path: '/used/cars/volkswagen-golf-gti-s/KP120WK',
    image: 'v1515582934/vehicle-cutout-vw_2x',
    roundel: 'low APR offer',
    offer: false
  }
]
const carCardDetailsWithoutOutline = [
  {
    model: 'Volkswagen Golf',
    derivative: 'GTI S',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: {
      total: 26999,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    path: '/used/cars/volkswagen-golf-gti-s/KP120WK',
    image: 'v1515582934/vehicle-cutout-vw_2x',
    roundel: 'low APR offer',
    offer: false
  },
  {
    model: 'Volkswagen Golf',
    derivative: 'GTI S',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: {
      total: 26999,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    path: '/used/cars/volkswagen-golf-gti-s/KP120WK',
    image: 'v1515582934/vehicle-cutout-vw_2x',
    offer: false
  },
  {
    model: 'Volkswagen Golf',
    derivative: 'GTI S',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: {
      total: 26999,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    path: '/used/cars/volkswagen-golf-gti-s/KP120WK',
    image: 'v1515582934/vehicle-cutout-vw_2x',
    offer: false
  },
  {
    model: 'Volkswagen Golf',
    derivative: 'GTI S',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: {
      total: 26999,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    path: '/used/cars/volkswagen-golf-gti-s/KP120WK',
    image: 'v1515582934/vehicle-cutout-vw_2x',
    offer: false
  }
]
const modelDerivativeCardDetails = [
  {
    model: 'Volkswagen Golf',
    derivative: 'Golf S',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: '£29,999',
    path: '/cars/new/model/volkswagen-golf-gti-s/',
    image: 'v1515582934/vehicle-cutout-vw_2x'
  },
  {
    model: 'Volkswagen Golf',
    derivative: 'Golf SE',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: '£29,999',
    path: '/cars/new/model/volkswagen-golf-gti-s/',
    image: 'v1515582934/vehicle-cutout-vw_2x'
  },
  {
    model: 'Volkswagen Golf',
    derivative: 'Golf SE Navigation',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: '£29,999',
    path: '/cars/new/model/volkswagen-golf-gti-s/',
    image: 'v1515582934/vehicle-cutout-vw_2x'
  },
  {
    model: 'Volkswagen Golf',
    derivative: 'Golf GT',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: '£29,999',
    path: '/cars/new/model/volkswagen-golf-gti-s/',
    image: 'v1515582934/vehicle-cutout-vw_2x'
  },
  {
    model: 'Volkswagen Golf',
    derivative: 'Golf GTI',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: '£29,999',
    path: '/cars/new/model/volkswagen-golf-gti-s/',
    image: 'v1515582934/vehicle-cutout-vw_2x'
  },
  {
    model: 'Volkswagen Golf',
    derivative: 'Golf GTD',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: '£29,999',
    path: '/cars/new/model/volkswagen-golf-gti-s/',
    image: 'v1515582934/vehicle-cutout-vw_2x'
  },
  {
    model: 'Volkswagen Golf',
    derivative: 'Golf GTE',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: '£29,999',
    path: '/cars/new/model/volkswagen-golf-gti-s/',
    image: 'v1515582934/vehicle-cutout-vw_2x'
  },
  {
    model: 'Volkswagen Golf',
    derivative: 'GTE Advance',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: '£29,999',
    path: '/cars/new/model/volkswagen-golf-gti-s/',
    image: 'v1515582934/vehicle-cutout-vw_2x'
  },
  {
    model: 'Volkswagen Golf',
    derivative: 'Golf R-Line',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: '£29,999',
    path: '/cars/new/model/volkswagen-golf-gti-s/',
    image: 'v1515582934/vehicle-cutout-vw_2x'
  },
  {
    model: 'Golf R',
    derivative: 'VW Golf R-Line',
    engine: '210-hp 2.0L Turbo',
    details: ['8,000 Miles'],
    price: '£29,999',
    path: '/cars/new/model/volkswagen-golf-gti-s/',
    image: 'v1515582934/vehicle-cutout-vw_2x'
  }
]

const featureListItems = [
  '0-62MPG: 14.4',
  'BHP: 59',
  'Width in mm: 1645',
  'Length in mm: 3563',
  'Height in mm: 3563',
  'Payload (KG): null',
  'UnladenWeightForVans: null',
  'Aspiration: NATURALLY ASPIRATED',
  'Max Torque lb.ft 70',
  'Drive Axle: FRONT',
  'DAB Digital radio',
  'Voice control',
  'Car App Connect',
  'Composition Media DAN+ radio system with 6.33" touch screen, voice enhancer, single MP3 compatible CD drive, SD card slot, USB interface, AUX IN socket'
]

const overviewFeatureListItems = [
  '19 inch Santiago alloys',
  'Anti-lock brake system',
  'Distance monitoring',
  '5.8 inch colour touch screen',
  'Electronic climate control'
]

const financeSummary = {
  monthlyPayment: {
    label: 'Monthly Payments',
    value: 341,
    prefix: '£',
    suffix: '',
    supplement: []
  },
  carPrice: {
    label: 'Car Price',
    value: 22896,
    prefix: '£',
    suffix: '',
    supplement: []
  },
  depositAmount: {
    label: 'Deposit Amount',
    value: 1245,
    prefix: '£',
    suffix: '',
    supplement: []
  },
  adminFee: {
    label: 'Admin Fee',
    value: 149,
    prefix: '£',
    suffix: '',
    supplement: []
  },
  balanceToFinance: {
    label: 'Balance to Finance',
    value: 22745,
    prefix: '£',
    suffix: '',
    supplement: []
  },
  numberOfPayments: {
    label: 'Term Length',
    value: 48,
    prefix: '',
    suffix: ' Months',
    supplement: []
  },
  firstPayment: {
    label: 'First Payment',
    value: 447,
    prefix: '£',
    suffix: '',
    supplement: []
  },
  finalPayment: {
    label: 'Optional Final Payment',
    value: 8786,
    prefix: '£',
    suffix: '',
    supplement: [
      {
        label: 'Includes Purchase Fee',
        value: 10,
        prefix: '£',
        suffix: '',
        supplement: []
      }
    ]
  },
  amountPayable: {
    label: 'Total Amount Payable',
    value: 28900.5,
    prefix: '£',
    suffix: '',
    supplement: []
  },
  interestCharges: {
    label: 'Interest Charges',
    value: 7480,
    prefix: '£',
    suffix: '',
    supplement: []
  },
  interestApr: {
    label: 'Representative APR',
    value: 11.9,
    prefix: '',
    suffix: '%',
    supplement: []
  },
  interestRate: {
    label: 'Interest Rate (fixed)',
    value: 11.28,
    prefix: '',
    suffix: '%',
    supplement: []
  }
}

const ctaListItems = [
  { label: 'View Offers', href: '#' },
  { label: 'Register Interest', href: '/book-test-drive' },
  { label: 'Download brochure', href: '#' }
]

const van = {
  name: 'Doublecab',
  category: 'van',
  heroImages: [],
  backgroundImages: [],
  lifestyleImages: [],
  capCode: null,
  id: '5aca979fac8dc50af2f11fc5',
  interior: [],
  exterior: [],
  environment: [],
  technical: [],
  dimensions: [
    {
      heading: 'Engine',
      subheading: "You've got the Power",
      description:
        'The Transporter Panel van offers a generation of engines featuring the Euro 6 emissions standard. All Transporter Panel vans include efficiency technologies as standard – consisting of low rolling resistance tyres, regenerative braking and Start/Stop. \n\nAvailable in TDI (Diesel) or TSI (Petrol)',
      images: ['placeholder']
    },
    {
      heading: 'Transmission/Power',
      subheading: 'Taking Things up a Gear',
      description:
        'Depending on your choice of engine and wheelbase, the Transporter Doublecab is available with a 6-speed manual or a 7-speed dual clutch direct shift gearbox (DSG), while an optimised chassis contributes to a dynamic driving experience. Our dual clutch direct shift gearbox (DSG) can be used as a fully automatic gearbox, or as a responsive quick-shift manual. The innovative dual clutch system facilitates an instant gear change, whilst helping to maintain swift and smooth progress. \n\nAvailable with: 6-speed manual or a 7-speed dual clutch direct shift gearbox (DSG)'
    },
    {
      heading: 'Wheel Base',
      subheading: 'Working with You',
      description:
        'The Transporter double cab is available with a long wheelbase which stands at an impressive 5,481mm in length with a rear loading platform of 2,056mm. \n\nAlso available with optional factory-fitted dropside body, ideal for any workload.'
    },
    {
      heading: 'Roof Height',
      subheading: 'Easy to Load. Loads of Space.',
      description:
        'When it comes to carrying your crew, the Transporter double cab can accommodate a crew of up to six with 3 seats in the front and a 3-seater bench row behind. It also comes with under seat luggage storage and four doors as standard so that getting on with your workday has never been easier. \n\nInterior also includes: dashboard illumination, Austin cloth upholstery, electric front windows and a lockable glove compartment. '
    }
  ],
  specifications: []
}

const ctaSpecItems = [
  {
    label: '1.0 TSI - 3 Door',
    model: 'Golf R',
    derivative: 'Golf R-Line',
    engine: '1.0 TSI',
    summary:
      "The Volkswagen Golf is simply a brilliant family car. In entry-level S trim, it covers all the basic amenities drivers will need and it's comfortable too. Unique exterior styling creates a powerful road presence, while sports running gear and lowered sports suspension helps hug the road, especially on corners. The Volkswagen Golf is simply a brilliant family car.",
    price: {
      total: 17765,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    specification: [
      {
        label: 'Size and Space',
        value: 3,
        decimal: 0,
        suffix: 'doors'
      },
      {
        label: 'Engine',
        value: 1.0,
        decimal: 1,
        suffix: 'Manual'
      },
      {
        label: 'Efficiency',
        value: 68.9,
        decimal: 1,
        suffix: 'MPG'
      },
      {
        label: 'Performance',
        value: 92,
        decimal: 0,
        suffix: 'PS'
      }
    ]
  },
  {
    label: '1.0 TSI - 5 Door',
    model: 'Golf R',
    derivative: 'Golf R-Line',
    engine: '1.0 TSI',
    summary:
      "The Volkswagen Golf is simply a brilliant family car. In entry-level S trim, it covers all the basic amenities drivers will need and it's comfortable too. Unique exterior styling creates a powerful road presence, while sports running gear and lowered sports suspension helps hug the road, especially on corners. The Volkswagen Golf is simply a brilliant family car.",
    price: {
      total: 17765,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    specification: [
      {
        label: 'Size and Space',
        value: 3,
        decimal: 0,
        suffix: 'doors'
      },
      {
        label: 'Engine',
        value: 1.0,
        decimal: 1,
        suffix: 'Manual'
      },
      {
        label: 'Efficiency',
        value: 68.9,
        decimal: 1,
        suffix: 'MPG'
      },
      {
        label: 'Performance',
        value: 92,
        decimal: 0,
        suffix: 'PS'
      }
    ]
  },
  {
    label: '1.4 TSI - 3 Door',
    model: 'Golf R',
    derivative: 'Golf R-Line',
    engine: '1.4 TSI',
    summary:
      "The Volkswagen Golf is simply a brilliant family car. In entry-level S trim, it covers all the basic amenities drivers will need and it's comfortable too. Unique exterior styling creates a powerful road presence, while sports running gear and lowered sports suspension helps hug the road, especially on corners. The Volkswagen Golf is simply a brilliant family car.",
    price: {
      total: 17765,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    specification: [
      {
        label: 'Size and Space',
        value: 3,
        decimal: 0,
        suffix: 'doors'
      },
      {
        label: 'Engine',
        value: 1.0,
        decimal: 1,
        suffix: 'Manual'
      },
      {
        label: 'Efficiency',
        value: 68.9,
        decimal: 1,
        suffix: 'MPG'
      },
      {
        label: 'Performance',
        value: 92,
        decimal: 0,
        suffix: 'PS'
      }
    ]
  },
  {
    label: '1.4 TSI - 5 Door',
    model: 'Golf R',
    derivative: 'Golf R-Line',
    engine: '1.4 TSI',
    summary:
      "The Volkswagen Golf is simply a brilliant family car. In entry-level S trim, it covers all the basic amenities drivers will need and it's comfortable too. Unique exterior styling creates a powerful road presence, while sports running gear and lowered sports suspension helps hug the road, especially on corners. The Volkswagen Golf is simply a brilliant family car.",
    price: {
      total: 17765,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    specification: [
      {
        label: 'Size and Space',
        value: 3,
        decimal: 0,
        suffix: 'doors'
      },
      {
        label: 'Engine',
        value: 1.0,
        decimal: 1,
        suffix: 'Manual'
      },
      {
        label: 'Efficiency',
        value: 68.9,
        decimal: 1,
        suffix: 'MPG'
      },
      {
        label: 'Performance',
        value: 92,
        decimal: 0,
        suffix: 'PS'
      }
    ]
  },
  {
    label: '1.6 TSI - 3 Door',
    model: 'Golf R',
    derivative: 'Golf R-Line',
    engine: '1.6 TSI',
    summary:
      "The Volkswagen Golf is simply a brilliant family car. In entry-level S trim, it covers all the basic amenities drivers will need and it's comfortable too. Unique exterior styling creates a powerful road presence, while sports running gear and lowered sports suspension helps hug the road, especially on corners. The Volkswagen Golf is simply a brilliant family car.",
    price: {
      total: 17765,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    specification: [
      {
        label: 'Size and Space',
        value: 3,
        decimal: 0,
        suffix: 'doors'
      },
      {
        label: 'Engine',
        value: 1.0,
        decimal: 1,
        suffix: 'Manual'
      },
      {
        label: 'Efficiency',
        value: 68.9,
        decimal: 1,
        suffix: 'MPG'
      },
      {
        label: 'Performance',
        value: 92,
        decimal: 0,
        suffix: 'PS'
      }
    ]
  },
  {
    label: '1.6 TSI - 5 Door',
    model: 'Golf R',
    derivative: 'Golf R-Line',
    engine: '1.6 TSI',
    summary:
      "The Volkswagen Golf is simply a brilliant family car. In entry-level S trim, it covers all the basic amenities drivers will need and it's comfortable too. Unique exterior styling creates a powerful road presence, while sports running gear and lowered sports suspension helps hug the road, especially on corners. The Volkswagen Golf is simply a brilliant family car.",
    price: {
      total: 17765,
      reserve: 299,
      installment: { payment: 550, plan: 'Month', code: 'MON' }
    },
    specification: [
      {
        label: 'Size and Space',
        value: 3,
        decimal: 0,
        suffix: 'doors'
      },
      {
        label: 'Engine',
        value: 1.0,
        decimal: 1,
        suffix: 'Manual'
      },
      {
        label: 'Efficiency',
        value: 68.9,
        decimal: 1,
        suffix: 'MPG'
      },
      {
        label: 'Performance',
        value: 92,
        decimal: 0,
        suffix: 'PS'
      }
    ]
  }
  // { label: '1.0 TSI - 5 Door', href: '#' },
  // { label: '1.4 TSI - 3 Door', href: '#' },
  // { label: '1.4 TSI - 5 Door', href: '#' },
  // { label: '1.6 TSI - 3 Door', href: '#' },
  // { label: '1.6 TSI - 5 Door', href: '#' }
]

const brandHeroCarouselImages = [
  {
    path: 'http://google.co.uk',
    image: 'v1515765106/carousel-image01_2x'
  },
  {
    path: 'http://bing.co.uk',
    image: 'v1515765106/carousel-image01_2x'
  },
  {
    path: 'http://yahoo.co.uk',
    image: 'v1515765106/carousel-image01_2x'
  }
]

const filterBarModelVWStub = [
  // {text: 'Volkswagen', value: 'vw-header', count: 10, brand: 'vw', onClick: this._setAll},
  { text: 'Volkswagen', value: 'vw-header', brand: 'vw' },
  { text: 'Beetle', value: 'vw-beetle', brand: 'vw', count: 28 },
  { text: 'Caddy', value: 'vw-caddy', brand: 'vw', count: 24 },
  { text: 'CC', value: 'vw-cc', brand: 'vw', count: 12 },
  { text: 'Golf', value: 'vw-golf', brand: 'vw', count: 4 },
  { text: 'Golf SV', value: 'vw-golfsv', brand: 'vw', count: 3 },
  { text: 'Jatta', value: 'vw-jatta', brand: 'vw', count: 8 },
  { text: 'Passat', value: 'vw-passat', brand: 'vw', count: 4 },
  { text: 'Passat CC', value: 'vw-passatcc', brand: 'vw', count: 22 },
  { text: 'Polo', value: 'vw-polo', brand: 'vw', count: 223 },
  { text: 'Scirocco', value: 'vw-scirocco', brand: 'vw', count: 21 }
]
const filterBarModelSkodaStub = [
  { text: 'Skoda', value: 'sk-header', brand: 'sk' },
  { text: 'Citigo', value: 'sk-citigo', brand: 'sk', count: 7 },
  { text: 'Fabia', value: 'sk-fabia', brand: 'sk', count: 11 },
  { text: 'Octavia', value: 'sk-octavia', brand: 'sk', count: 43 },
  { text: 'Rapid', value: 'sk-rapid', brand: 'sk', count: 1 },
  { text: 'Superb', value: 'sk-superb', brand: 'sk', count: 17 },
  { text: 'Yeti', value: 'sk-yeti', brand: 'sk', count: 3 },
  { text: 'Yeti outdoor', value: 'sk-yeti-outdoor', brand: 'sk', count: 9 }
]

const filterBarMakeStub = [
  { text: 'Volkswagen', value: 'volkswagen', count: 10 },
  { text: 'Skoda', value: 'skoda', count: 91 },
  { text: 'Audi', value: 'audi', count: 519 },
  { text: 'Ford', value: 'ford', count: 550 },
  { text: 'AMC', value: 'amc', count: 160 },
  { text: 'Kia', value: 'kia', count: 234 },
  { text: 'Nissan', value: 'nissan', count: 286 },
  { text: 'Toyota', value: 'toyota', count: 90 },
  { text: 'Vauxhall', value: 'vauxhall', count: 501 }
]

const filterBarTypeStub = [
  { value: 'cars', text: 'Cars' },
  { value: 'vans', text: 'Vans' }
]

const filterBarPriceStub = {
  pm: [
    { text: 'No Maximum', value: 'nomax' },
    { text: 'Up to £100pm', value: '100', count: 40 },
    { text: 'Up to £150pm', value: '150', count: 512 },
    { text: 'Up to £200pm', value: '200', count: 54 },
    { text: 'Up to £250pm', value: '250', count: 32 },
    { text: 'Up to £300pm', value: '300', count: 42 }
  ],
  fp: [
    { text: 'No Maximum', value: 'nomax' },
    { text: 'Up to £6,000', value: '6000', count: 10 },
    { text: 'Up to £7,000', value: '7000', count: 12 },
    { text: 'Up to £8,000', value: '8000', count: 54 },
    { text: 'Up to £9,000', value: '9000', count: 32 },
    { text: 'Up to £10,000', value: '10000', count: 42 }
  ]
}

const dealershipDetail = {
  location: 'Citygate Chalfont',
  wednesdayServiceHours: '08:30 – 19:00',
  addressLine1: 'Station Approach',
  addressLine2: 'Little Chalfont',
  addressLine3: null,
  town: 'Amersham',
  county: 'Buckinghamshire',
  postcode: 'HP7 9PN',
  enquiriesTelephone: '020 3199 3680',
  serviceBookingTelephone: '0330 012 0242',
  description:
    '<p style="box-sizing: border-box; margin: 0px 0px 12px; padding: 0px; border: 0px; font-variant-numeric: inherit; font-variant-east-asian: inherit; font-stretch: inherit; font-size: 14px; line-height: 25px; font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif; vertical-align: baseline; color: rgb(0, 0, 0);">Looking for your nearest VW dealer? At Citygate Chalfont, we&rsquo;re committed to maintaining the highest levels of dealership standards at all times. Whether you&rsquo;re searching for a new or used vehicle or booking a service with VW, Little Chalfont&rsquo;s branch is run by a team of friendly and approachable staff. With excellent customer service as standard, we&rsquo;ll use our knowledge and expertise to assist you - whatever your needs.&nbsp;</p><p style="box-sizing: border-box; margin: 0px 0px 12px; padding: 0px; border: 0px; font-variant-numeric: inherit; font-variant-east-asian: inherit; font-stretch: inherit; font-size: 14px; line-height: 25px; font-family: &quot;Open Sans&quot;, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif; vertical-align: baseline; color: rgb(0, 0, 0);">At Citygate Chalfont, you&rsquo;re guaranteed a hot drink and a warm welcome every time.</p>',
  mondaySalesHours: '08:30 – 19:00',
  mondayServiceHours: '08:30 – 19:00',
  tuesdaySalesHours: '08:30 – 19:00',
  tuesdayServiceHours: '08:30 – 19:00',
  wednesdaySalesHours: '08:30 – 19:00',
  id: '5a6b104630cb255074e121ff',
  thursdaySalesHours: '08:30 – 19:00',
  thursdayServiceHours: '08:30 – 19:00',
  fridaySalesHours: '08:30 – 19:00',
  fridayServiceHours: '08:30 – 19:00',
  saturdaySalesHours: '08:30 – 19:00',
  saturdayServiceHours: '08:30 – 19:00',
  sundaySalesHours: '08:30 – 19:00',
  sundayServiceHours: '08:30 – 19:00',
  slug: 'citygate-chalfont',
  contactEmail: 'help@citygate.co.uk',
  liveChatMerchantId: 477511,
  liveChatProviderId: 19600,
  createdDate: '2018-01-26T11:13:18.484Z',
  vehicles: [{ name: 'Volkswagen', shortName: 'VW', slug: 'volkswagen' }],
  images: []
}

const casestudyBrands = [
  { title: 'NHS', img: 'logo-nhs' },
  { title: 'RAC', img: 'logo-rac' },
  { title: 'British Transport Police', img: 'logo-british-transport-police' },
  { title: 'ZSL London Zoo', img: 'logo-zsl-london-zoo' },
  {
    title: 'Arbor Tree Surgeon Services',
    img: 'logo-arbor-tree-surgeon-services'
  },
  { title: 'London Fire Brigade', img: 'logo-lfb' }
]

const careersItems = [
  { location: 'High Wycombe', title: 'Sales Executive', href: '#' },
  { location: 'Colindale', title: 'Bodyshop Paint Technician', href: '#' },
  {
    location: 'Wooburn Green',
    title: 'Senior Business Development Manager',
    href: '#'
  },
  { location: 'All Locations', title: 'Bodyshop Paint Technician', href: '#' },
  { location: 'Colindale', title: 'SMART Repairs', href: '#' },
  { location: 'Within Group', title: 'Showroom Manager', href: '#' },
  {
    location: 'High Wycombe',
    title: 'Communication Centre Advisor',
    href: '#'
  },
  {
    location: 'Watford',
    title: 'Commercial Vehicles Sales Executive',
    href: '#'
  }
]

const careersDetails = [
  {
    title: 'About the role',
    text: 'Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Donec ullamcorper nulla non metus auctor fringilla. Etiam porta sem malesuada magna mollis euismod.'
  },
  {
    title: 'What we’re looking for',
    text: 'Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Curabitur blandit tempus porttitor. Vestibulum id ligula porta felis euismod semper.Cras justo odio, dapibus ac facilisis in, egestas eget quam. Etiam porta sem malesuada magna mollis euismod.'
  },
  {
    title: 'About CityGate',
    text: 'Nulla vitae elit libero, a pharetra augue. Etiam porta sem malesuada magna mollis euismod.'
  },
  {
    title: 'More info',
    text: 'Sed posuere consectetur est at lobortis. Curabitur blandit tempus porttitor. Donec sed odio dui.'
  }
]

const reviews = [
  {
    firstName: 'Rob',
    lastName: 'McCardle',
    review:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem earum beatae soluta enim omnis ipsam delectus? Quos corporis reiciendis perferendis.',
    stars: 2,
    date: '2015-01-25T00:00:00.000'
  },
  {
    firstName: 'Paul',
    lastName: 'Serby',
    review:
      'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Praesentium asperiores recusandae error enim magni neque exercitationem totam quidem quas minima. Maiores, laborum ipsum consequuntur facere numquam aut perferendis ipsam fugiat?',
    stars: 4,
    date: '2018-04-13T00:00:00.000'
  },
  {
    firstName: 'James',
    lastName: 'Jordan',
    review:
      'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dolore, provident!',
    stars: 5,
    date: '2017-10-01T00:00:00.000'
  }
]

const reviewsData = {
  total: 239,
  average: 3.5
}

const titles = ['Mr', 'Mrs', 'Miss', 'Ms']

export {
  casestudyBrands,
  careersItems,
  careersDetails,
  titles,
  dealershipDetail,
  searchItems,
  sections,
  subSections,
  contextSections,
  contextMakesSections,
  brands,
  Link,
  article,
  articles,
  ctaSpecItems,
  van,
  signpostArticles,
  carCardDetails,
  carCardDetailsWithoutOutline,
  carCardDetailsOutlineOnly,
  carCardPopularModelsDetails,
  modelDerivativeCardDetails,
  ctaListItems,
  brandHeroCarouselImages,
  featureListItems,
  overviewFeatureListItems,
  footerSiteLinks,
  sliderRange,
  filterState,
  filterSort,
  financeSummary,
  get360ShowcaseImages,
  get360PosterFrame,
  getPanoramaPoster,
  getPanoramaImage,
  filterBarModelVWStub,
  filterBarModelSkodaStub,
  filterBarMakeStub,
  filterBarTypeStub,
  filterBarPriceStub,
  reviews,
  reviewsData
}
